import { GeoJSON, Point } from "geojson";
import { IDisplaySection, DatasetRecord, DisplayItem } from "@/types";
import { AddressLocation } from "@/types/location/AddressLocation";
import { GammaAccuracy } from "@/types/location/location-accuracy";
export class DatasetLocation extends AddressLocation {
  declare record: DatasetRecord;

  constructor(data: { record: DatasetRecord; type: "Policy" | "Claim" }) {
    super({
      ...data,
      geometry: data.record.geometry as GeoJSON.Point,
      address: {
        address: data.record.addressLineArray.length
          ? data.record.addressLineArray
          : (data.record.value.address || data.record.value.Address)?.split(
              ","
            ) || ["Address not found"],
        addressProvider: "Native",
        country: "GBR",
      },
    });
  }

  get addressLinkRequest() {
    const Address = {
      ...this.address,
      ...this.record.requestPartial,
    };
    if (typeof this.precisionAccuracy === "number") {
      const addressIdIndex = this._data.record?.columnDefinitions.findIndex(
        (x) => x.context === "AddressId"
      );
      if (this.precisionAccuracy === 110)
        return { Coordinates: (this.geometry as Point)?.coordinates };
      else if (this.precisionAccuracy < 200) return { Geometry: this.geometry };
      else
        return {
          Address:
            addressIdIndex && addressIdIndex >= 0
              ? {
                  matchLevel: 0,
                  country: "IRL",
                  ecadId: this._data.record?.data[addressIdIndex],
                }
              : Address,
        };
    }
    return { Address };
  }

  get precisionAccuracy(): GammaAccuracy | undefined {
    return this.record.precisionAccuracy;
  }

  get title() {
    return this.record.uniqueIdentifier;
  }

  get displaySections(): IDisplaySection[] {
    const items = Object.keys(this.record.visibleProps).map(
      (key) =>
        new DisplayItem(
          { value: this.record.visibleProps[key] },
          this.record.columnDefinitionsMap.get(key)
        )
    );

    return super.displaySections.concat([
      {
        name: "Details",
        type: "Table",
        items,
      },
    ]);
  }

  get urlParams(): Record<string, any> {
    return this.record.toJson;
  }
}
